import type { RunEvent } from "@/lib/agent-run-progress"

/**
 * Server-pushed custom agent run progress (BroadcastService MESSAGE_AGENT_RUN)
 * for the homepage's in-progress feed cards. The feed cache is patched in
 * place for live progress, then reconciled after a run finishes.
 */

type Listener = (event: RunEvent) => void

const listeners = new Set<Listener>()
const reconnectListeners = new Set<() => void>()

export function dispatchAgentRunEvent(event: RunEvent) {
  listeners.forEach((listener) => listener(event))
}

/** Subscribe; returns the unsubscribe function. */
export function onAgentRunEvent(listener: Listener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** A socket reconnect may have missed run events; the feed should reconcile. */
export function dispatchAgentRunReconnect() {
  reconnectListeners.forEach((listener) => listener())
}

export function onAgentRunReconnect(listener: () => void) {
  reconnectListeners.add(listener)
  return () => {
    reconnectListeners.delete(listener)
  }
}
